import { render, staticRenderFns } from "./issues-table.vue?vue&type=template&id=2b63754c&scoped=true&"
import script from "./issues-table.vue?vue&type=script&lang=js&"
export * from "./issues-table.vue?vue&type=script&lang=js&"
import style0 from "./issues-table.vue?vue&type=style&index=0&id=2b63754c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63754c",
  null
  
)

export default component.exports